import { render, staticRenderFns } from "./TalkWithGuideBox.vue?vue&type=template&id=f0ee3058&"
import script from "./TalkWithGuideBox.vue?vue&type=script&lang=js&"
export * from "./TalkWithGuideBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports